import { render, staticRenderFns } from "./CommentPostDateParts.vue?vue&type=template&id=40446efa&scoped=true"
import script from "./CommentPostDateParts.vue?vue&type=script&lang=ts"
export * from "./CommentPostDateParts.vue?vue&type=script&lang=ts"
import style0 from "./CommentPostDateParts.vue?vue&type=style&index=0&id=40446efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40446efa",
  null
  
)

export default component.exports